const defaultState = {
	selectOptions: {
		plants: [],
		serviceKinds: [],
		procTypes: [],
		procKinds: []
		// outDevs: [],
		// inDevs: []
	},

	searchParams: {
		plantCd: null,
		serviceKind: 'ALL',
		procType: 'ALL',
		procId: null,
		procName: null
	},

	pagingInfo: {
		currentPage: 1,
		pageUnit: 20
	},

	popupParams: {
		type: '',
		show: false,
		selectedRow: {}
	},

	processes: []
};
export default {
	...JSON.parse(JSON.stringify(defaultState))
};
export { defaultState };
